import * as React from 'react';
import { AppIcons, ButtonObject, DefaultButton, XIAppIcon, XISVG } from '@inmoment/the-kitchen';
import './ErrorPage.css';

interface ErrorPageProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  subtitle?: string;
  text?: string;
  icon?: AppIcons;
  buttons?: { action: ButtonObject };
}
export const ErrorPage: React.FC<ErrorPageProps> = React.forwardRef<HTMLDivElement, ErrorPageProps>((props, ref) => {
  const { title, className, subtitle, text, icon, buttons, ...ingredients } = props;

  return (
    <div className={`${className || ''} error-page-wrapper`} {...ingredients} ref={ref}>
      <div className={'error-page-content-wrapper'}>
        {icon && !title && (
          <div className={'error-page-app-icon-wrapper'}>
            <XIAppIcon stretch icon={icon} />
          </div>
        )}
        {title && (
          <p className="kxi-text-center kxi-text-600" style={{ marginBottom: 24, fontSize: 84 }}>
            {title}
          </p>
        )}
        {subtitle && (
          <p className="kxi-text-center kxi-text-600 kxi-text-xlarge" style={{ marginBottom: 24 }}>
            {subtitle}
          </p>
        )}
        {text && <p className="kxi-text-center kxi-text-small">{text}</p>}
        {buttons && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              margin: '60px auto 0 auto',
            }}
          >
            <DefaultButton
              buttonSize={'normal'}
              text={buttons.action.text}
              fill={'outline'}
              color={'CX'}
              contrast={'high'}
              onClick={buttons.action.onClick}
              data-testid={'actionButton'}
            />
          </div>
        )}
      </div>

      <div className={'error-page-square-1'} />
      <div className={'error-page-square-2'} />
      <div className={'error-page-square-3'} />
      <div className={'error-page-square-4'} />
      <div className={'error-page-square-5'} />
      <div className={'error-page-square-6'} />
      {title && (
        <React.Fragment>
          <div className={'star-1'}>
            <XISVG svg={'star_pointed'} />
          </div>
          <div className={'star-2'}>
            <XISVG svg={'star_circle'} />
          </div>
          <div className={'star-3'}>
            <XISVG svg={'star_pointed'} />
          </div>
          <div className={'star-4'}>
            <XISVG svg={'star_circle'} />
          </div>
          <div className={'star-5'}>
            <XISVG svg={'star_pointed'} />
          </div>
          <div className={'star-6'}>
            <XISVG svg={'star_circle'} />
          </div>
          <div className={'star-7'}>
            <XISVG svg={'star_circle'} />
          </div>
          <div className={'star-8'}>
            <XISVG svg={'star_circle'} />
          </div>
          <div className={'star-9'}>
            <XISVG svg={'star_pointed'} />
          </div>
          <div className={'error-page-planet-1'}>
            <XISVG svg={'planet_1'} />
          </div>
          <div className={'error-page-planet-2'}>
            <XISVG svg={'planet_2'} />
          </div>
        </React.Fragment>
      )}
    </div>
  );
});
